import React, { useEffect, useState } from 'react'
// import { Button, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import imgTitle from 'assets/images/eventWater/imgTitleModal.png'
import imgIpadModal from 'assets/images/eventWater/imgIpadModal.png'
import imgMiPadModal from 'assets/images/eventWater/imgMiPadModal.png'
import imgMoneyModal from 'assets/images/eventWater/imgMoneyModal.png'
import imgMoney from 'assets/images/eventWater/imgMoney.png'
import imgIpad from 'assets/images/eventWater/imgIpad.png'
import imgMipad from 'assets/images/eventWater/imgMiPad.png'
import iconClose from 'assets/images/eventWater/iconClose.png'
import { getData, setData } from 'utils/localStorage'
import { useQuery } from 'react-query'
import { getCheckEventWaterQuery, getRankEventWaterQuery } from 'dataLayer/game'
import { Button, Modal } from 'react-bootstrap'
import { getUserQuery } from 'dataLayer/user'

const WinnerThingyan = prop => {
	const { t } = useTranslation()
	const innerheight = window.innerHeight
	const { data: eventWater, isLoading: isLoadingEvent } = useQuery(
		getCheckEventWaterQuery(),
	)
	const { data: user, isLoading: isLoadingUser } = useQuery(getUserQuery())
	const [openModal, setOpenModal] = useState(false)
	const { data } = useQuery(getRankEventWaterQuery())
	const handleCancel = () => {
		setOpenModal(false)
	}
	const [winnerPopup, setWinnerPopup] = useState(0)
	useEffect(() => {
		console.log(eventWater?.is_finished, eventWater?.is_show, data)
		if (eventWater?.is_show && eventWater?.is_finished) {
			if (user) {
				if (data && data?.ranks) {
					const listIdUserTop = [
						data?.ranks?.data[0]?.userId,
						data?.ranks?.data[1]?.userId,
						data?.ranks?.data[2]?.userId,
					]
					const indexUserTop = listIdUserTop.indexOf(user.id)
					if (indexUserTop !== -1) {
						const checkWatched = getData(
							`watched_pop_up_${indexUserTop + 1}_${user.id}`,
						)
						if (checkWatched) {
						} else {
							setOpenModal(true)
							setWinnerPopup(indexUserTop)
							setData(`watched_pop_up_${indexUserTop + 1}_${user.id}`, true)
						}
					} else {
						const checkWatched = getData('watched_pop_up_4')
						if (checkWatched) {
						} else {
							setOpenModal(true)
							setWinnerPopup(3)
							setData('watched_pop_up_4', true)
						}
					}
				}
			} else {
				const checkWatched = getData('watched_pop_up_4')
				if (checkWatched) {
				} else {
					setOpenModal(true)
					setWinnerPopup(3)
					setData('watched_pop_up_4', true)
				}
			}
		}
	}, [data, eventWater, user])

	const listItem = [
		{
			imgGift: imgMoneyModal,
			description: t('event.water.result.top_1'),
		},
		{
			imgGift: imgIpadModal,
			description: t('event.water.result.top_2'),
		},
		{
			imgGift: imgMiPadModal,
			description: t('event.water.result.top_3'),
		},
	]
	return (
		<Modal
			centered
			show={openModal}
			onHide={handleCancel}
			className={`modal-winner-event ${winnerPopup === 3 ? 'modal-all' : ''}`}
			width="453px"
			style={{ height: `${innerheight}px` }}
		>
			<span onClick={handleCancel} className="btn-close">
				<img src={iconClose} alt="close" />
			</span>
			<div className="winning">
				<span className="winning-title">
					<img src={imgTitle} alt="title" />
				</span>
				{[0, 1, 2].indexOf(winnerPopup) !== -1 && (
					<span className="winning-gift">
						<img src={listItem[winnerPopup].imgGift} alt="gift" />
					</span>
				)}
				<div className="winning-foot">
					{[0, 1, 2].indexOf(winnerPopup) !== -1 && (
						<div className="winning-foot-text">
							{listItem[winnerPopup].description}
						</div>
					)}
					{winnerPopup === 3 && (
						<div className="winning-foot-gift">
							<div className="winning-foot-gift-box">
								<div className="winning-foot-gift-box-item">
									<div className="item-rank">1st prize</div>
									<img src={imgMoney} alt="icon gift" />
									<div className="item-info">
										<span>{data?.ranks?.data[0]?.full_name}</span>
										<span>{data?.ranks?.data[0]?.msisdn}</span>
									</div>
								</div>
								<div className="winning-foot-gift-box-item">
									<div className="item-rank">2nd prize</div>
									<img src={imgIpad} alt="icon gift" />
									<div className="item-info">
										<span>{data?.ranks?.data[1]?.full_name}</span>
										<span>{data?.ranks?.data[1]?.msisdn}</span>
									</div>
								</div>
								<div className="winning-foot-gift-box-item">
									<div className="item-rank">3rd prize</div>
									<img src={imgMipad} alt="icon gift" />
									<div className="item-info">
										<span>{data?.ranks?.data[2]?.full_name}</span>
										<span>{data?.ranks?.data[2]?.msisdn}</span>
									</div>
								</div>
							</div>
							<div className="winning-foot-gift-text">
								{t('event.water.result.all')}
							</div>
						</div>
					)}
					<Button key="submit" type="primary" onClick={handleCancel}>
						{t('event.water.result.close')}
					</Button>
				</div>
			</div>
		</Modal>
	)
}

export default WinnerThingyan
